// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3-UlQ","error":"Textarea_error__2jNo6","readonly":"Textarea_readonly__ar4D1","disabled":"Textarea_disabled__3NL2K"};